// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "./common"
import Vue from 'vue'
import FullPageApp from '@/FullPageApp'
import router from '@/router/paynow'
import store from "@/store/paynow"
import cbClient from "@/utils/cb-client"
cbClient.syncWithStore(store)
store.dispatch("init_auth");

window.cbjsLoader.then(() => {
  Chargebee.getInstance().setReferrerModule("paynow_v3")
})

router.customPush = (options) => {
  options.query = options.query || {};
  if(store.state.config.entry_point) {
    options.query["source"] = store.state.config.entry_point;
  }
  router.push(options);
}

router.customReplace = (options) => {
  options.query = options.query || {};
  if(store.state.config.entry_point) {
    options.query["source"] = store.state.config.entry_point;
  }
  router.replace(options);
}

new Vue({
  router: router,
  store: store,
  render: h => h(FullPageApp)
}).$mount("#paynow");
